import * as HTTP from "./http";

export interface LoginResponse {
  token: string;
}

export interface IPasswordChangePayload {
  old_password: string
  password: string
  password2: string
}

export function login(username: string, password: string): Promise<LoginResponse> {
  return HTTP.post("/api-token-auth/", {
    username,
    password
  })
    .then(async r => {
      const response = await r.json();
      if (!r.ok) {
        throw new Error(response.non_field_errors ? response.non_field_errors[0] : "Unable to sign you in.");
      }
      return response;
    });
}

export function changePassword(payload: IPasswordChangePayload) {
  return HTTP.patch("/api/v1/users/password/", { ...payload })
    .then(r => {
      if (!r.ok) throw new Error("Unable to change password. Please try again.");
      return r.json();
    });
}
